import {
	Box,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	InputAdornment
} from "@mui/material";
import React, { useEffect } from "react";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../scenarioSetupNewSlice";


const commonHeight = sizes.h35;
const SW = sizes.w300;

export default function DefineScenarioSettings() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const {
		minimumQuota,
		selectedScSTQ,
		selectedScUB,
		selectedScModifySTQ,
		scenarioSTQ,
		criticalityList,
		criticalityId,
		selectedPGs
	} = setupState;
	const minQuotaConfig = {
		default: { label: "", margin: "0px" },
		mgmcg: { label: "in mg/mcg", margin: "-103px"},
		packs: { label: "in packs", margin: "-83px"},
	};
	const [selectedConfig, setSelectedConfig] = React.useState(minQuotaConfig.default);
	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		dispatch(setState(stateName, value));
	};
	useEffect(() => {
		const config = selectedPGs.length === 0
			? minQuotaConfig.default
			: selectedPGs.every((x) => x.type === "PG" || x.productGroupID > 0)
			? minQuotaConfig.mgmcg
			: minQuotaConfig.packs;
		setSelectedConfig(config);
	},[selectedPGs]);
	return (
		<Box sx={{ mt: 4 }}>
			{/* <hr style={{
     border: ".25px solid #c6c6c6",
    }}/> */}
			{/* <Box sx={{ mt: 4}}>
				<Typography sx={{ color: "lightBlue.main", fontWeight: "bold" }} className="compHeading">
					Define Scenario Settings
				</Typography>
			</Box> */}
			<Box sx={{ mt: 4 }}>
				<Grid container spacing={2} columns={12} alignContent={"space-between"}>
					<Grid item sm={6} md={3} lg={2.4}>
						<Box>
							<TextField sx={{width:"100%"}}
								type={"number"}
								id="outlined-basic"
								label="Minimum Quota Value"
								variant="outlined"
								size="small"
								value={minimumQuota}
								onChange={(event) =>{
									const inputValue = parseFloat(event.target.value);
    								if (isNaN(inputValue) || inputValue >= 0) {
										handleStateUpdate(event, "minimumQuota")
									}
								}}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end" sx = {{ml: selectedConfig.margin}}>
											<span style={{ fontSize: '0.95rem', color: 'black' , paddingRight : selectedConfig.label==""? "0px" :"15px" , 
											userSelect: "none", pointerEvents : "none"}}>{selectedConfig.label} </span>
										</InputAdornment>
									),
								}}
								InputLabelProps={{
									shrink: true, 
								}}
							/>
						</Box>
					</Grid>

					<Grid item sm={6} md={3} lg={2.4}>
						<Box>
							<FormControl sx={{width:"100%"}}>
								<InputLabel id="demo-simple-select-label">
									Scenario Criticality
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									label="Country"
									value={criticalityId}
									className="montserratFont"
									onChange={(event) =>
										handleStateUpdate(event, "criticalityId")
									}
								>
									{criticalityList?.map((source, index) => {
											return (
												<MenuItem key={index} value={source.scenarioCriticalityID}>
													{source.scenarioCriticalityDesc}
												</MenuItem>
											);
										return null;
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid>

					<Grid item sm={6} md={3} lg={2.4}>
						<Box>
							<FormControl sx={{width:"100%"}}>
								<InputLabel id="demo-simple-select-label">
									Scenario Stick to Quota
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={selectedScSTQ}
									label="Scenario Stick to Quota"
									sx={{
										height: commonHeight,
										width: SW,
										color: "black.main",
										mt: 1,
									}}
									onChange={(event) =>
										handleStateUpdate(event, "selectedScSTQ")
									}
								>
									{scenarioSTQ.map((item, index) => {
										return (
											<MenuItem key={index} value={item.value}>
												{item.value}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid>
					<Grid item sm={6} md={3} lg={2.4}>
					<Box>
						<FormControl sx={{ width: "100%" }}>
						<InputLabel id="demo-simple-select-label">
							Scenario Unblock Full Order
						</InputLabel>
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							value={selectedScUB}
							label="Scenario Unblock Full Order"
							sx={{
							height: commonHeight,
							width: SW,
							color: "black.main",
							mt: 1,
							}}
							onChange={(event) =>
							handleStateUpdate(event, "selectedScUB")
							}
						>
							{scenarioSTQ.map((item, index) => {
							return (
								<MenuItem key={index} value={item.value}>
								{item.value}
								</MenuItem>
							);
							})}
						</Select>
						</FormControl>
					</Box>
					</Grid>
					<Grid item sm={6} md={3} lg={2.4}>
					<Box>
						<FormControl sx={{ width: "100%" }}>
						<InputLabel id="demo-simple-select-label">
							Scenario Modify + Stick to Quota
						</InputLabel>
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							value={selectedScModifySTQ}
							label="Scenario Modify + Stick to Quota"
							sx={{
							height: commonHeight,
							width: SW,
							color: "black.main",
							mt: 1,
							}}
							onChange={(event) =>
							handleStateUpdate(event, "selectedScModifySTQ")
							}
						>
							{scenarioSTQ.map((item, index) => {
							return (
								<MenuItem key={index} value={item.value}>
								{item.value}
								</MenuItem>
							);
							})}
						</Select>
						</FormControl>
					</Box>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
}
